export default __webpack_public_path__ + "static/media/index.fc9821b3.less";